import { useEffect, useState } from "react";
import websitePoster from "../Images/WebsitePoster.png";
import mobilePoster from "../Images/MobilePoster.jpeg";

function Hero() {
  const [isMobile, setIsMobile] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const scrollToRegistration = () => {
    const element = document.getElementById("registration");

    if (element) {
      const top = element.offsetTop - 60;

      window.scrollTo({
        top,
        behavior: "smooth"
      });
    }
  };

  const handleClick = () => {
    setIsPressed(true);

    setTimeout(() => {
      scrollToRegistration();
      setIsPressed(false);
    }, 150);
  };

  return (
    <section
      style={{
        height: "90vh",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${isMobile ? mobilePoster : websitePoster})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      {/* FLOATING BUTTON */}
      <button
        onClick={handleClick}
        style={{
          position: "absolute",

          // 📱 mobile adjusted
          bottom: isMobile ? "10%" : "20%",

          left: "50%",

          transform: `translateX(-50%) ${
            isPressed ? "scale(0.95)" : "scale(1)"
          }`,

          padding: "16px 34px",
          borderRadius: "14px",
          border: "none",
          background: "#fff",
          color: "#000",
          fontSize: "16px",
          fontWeight: "600",
          cursor: "pointer",

          boxShadow: isPressed
            ? "0 8px 20px rgba(0,0,0,0.25)"
            : "0 14px 35px rgba(0,0,0,0.28)",

          transition: "all 0.15s ease",

          // 💻 desktop floats only
          animation: isMobile
            ? "none"
            : "floatButton 3s ease-in-out infinite"
        }}
      >
        Click to Register

        <style>
          {`
            @keyframes floatButton {
              0% {
                transform: translateX(-50%) translateY(0px);
              }
              50% {
                transform: translateX(-50%) translateY(-10px);
              }
              100% {
                transform: translateX(-50%) translateY(0px);
              }
            }
          `}
        </style>
      </button>
    </section>
  );
}

export default Hero;